import { createContext } from "react";

const ModalManagerContext = createContext(null);

export { ModalManagerContext };
